/////////////////////////////////////////////////////////
// Marketplace user roles (Sharetribe user types).       //
/////////////////////////////////////////////////////////

// The available user types are configured in the Sharetribe Console
// (Build > Content > User types) and delivered via the hosted `userTypes`
// asset. We deliberately keep the two role-defining IDs in one place so the
// UI can route the two sign-up journeys separately:
//
//   - The header "Sign up" button is for CUSTOMERS (shoppers) only.
//   - The "Verified Seller" (provider) journey is demoted to a footer
//     call-to-action so the header stays focused on shoppers.
//
// These IDs must match the user-type IDs in the hosted config. If you rename a
// user type in the Console, update the matching value here.
export const CUSTOMER_USER_TYPE = 'Shopper';
export const SELLER_USER_TYPE = 'Verified-Seller';

// Sellers sign up and sell as a brand rather than as an individual, so
// seller-facing forms swap personal wording ("display name", "profile picture")
// for brand wording ("brand name", "brand logo").
export const isSellerUserType = userType => userType === SELLER_USER_TYPE;
